<div class="w-full flex justify-center">
  <div class="max-w-[1800px] w-full">
    <zaeper-page-layout [title]="'Rechnungsübersicht'" [pageLayout]="ePageLayout.CARDS" [navigation]="navigation">
      <ng-template zTemplate="header">
        <zaeper-icon fontSet="material-icons-outlined">receipt_long</zaeper-icon>
      </ng-template>

      <div class="flex flex-col gap-6">
        <p-card>
          <ng-template pTemplate="header">
            <div class="px-4 pt-4">
              <h3 class="text-lg font-semibold m-0">Rechnungen</h3>
              <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">Übersicht deiner bisherigen Rechnungen</p>
            </div>
          </ng-template>

          <p-table [value]="invoices" [loading]="isLoading" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template pTemplate="header">
              <tr>
                <th>Rechnungsnummer</th>
                <th>Datum</th>
                <th>Betrag</th>
                <th>Status</th>
                <th class="text-right">Aktionen</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-invoice>
              <tr>
                <td class="font-medium">{{ invoice.stripeInvoiceId }}</td>
                <td>{{ formatDate(invoice.createdAt) }}</td>
                <td>{{ formatCurrency(invoice.amountDue, invoice.currency) }}</td>
                <td>
                  <p-tag [value]="getStatusLabel(invoice.status)" [severity]="getStatusSeverity(invoice.status)"/>
                </td>
                <td class="text-right">
                  <p-button
                    icon="pi pi-external-link"
                    [outlined]="true"
                    [rounded]="true"
                    [text]="true"
                    pTooltip="Rechnung anzeigen"
                    [disabled]="!invoice.hostedInvoiceUrl"
                    (onClick)="viewInvoice(invoice)"/>
                  <p-button
                    icon="pi pi-download"
                    [outlined]="true"
                    [rounded]="true"
                    [text]="true"
                    pTooltip="PDF herunterladen"
                    [disabled]="!invoice.invoicePdfUrl"
                    (onClick)="downloadInvoice(invoice)"/>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="text-center py-8 text-surface-500 dark:text-surface-400">
                  Keine Rechnungen vorhanden
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </div>
    </zaeper-page-layout>
  </div>
</div>
